<template>
    <div>
        <ValidationObserver ref="educationInfoFormValidate">
            <h6>{{ $t('high_school_info') }}</h6>
            <div class="border p-4 rounded-sm mb-3">
                <b-row>
                    <b-col cols="12" md="6" lg="4">
                        <b-form-group :label="$t('high_school_name')">
                            <ValidationProvider name="school_name" rules="" v-slot="{ errors }">
                                <b-form-input v-model="localFormData.school"
                                              :disabled="isReadOnly"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="school_city_id" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('school') + ' ' + $t('city')">
                                <city-selectbox v-model="localFormData.school_city_id"
                                                :disabled="isReadOnly"
                                                :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="school_district_id" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('school') + ' ' + $t('district')">
                                <district-outline-selectbox v-model="localFormData.school_district_id"
                                                            :city_id="localFormData.school_city_id"
                                                            :disabled="isReadOnly"
                                                            :validateError="errors[0]" />
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="4">
                        <ValidationProvider name="class" rules="" v-slot="{ errors }">
                            <b-form-group :label="$t('class')">
                                <ParameterSelectbox code="bisep_application.high_school_classes" :public="true" v-model="localFormData.class" :disabled="isReadOnly" :validateError="errors[0]"/>
                            </b-form-group>
                        </ValidationProvider>
                    </b-col>
                    <b-col cols="12" md="6" lg="8">
                        <b-form-group :label="$t('high_school_score')">
                            <ValidationProvider name="school_diploma_point" rules="dynamic_between:1,100" v-slot="{ errors }">
                                <b-form-input v-model="localFormData.graduation_average"
                                              type="number"
                                              :disabled="isReadOnly"
                                              :state="errors[0] ? false : null" />
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
                                <b-form-text>{{ $t('high_school_score_info') }}</b-form-text>
                            </ValidationProvider>
                        </b-form-group>
                    </b-col>
                </b-row>
            </div>
            <b-row>
                <b-col cols="12">
                    <b-alert variant="info" show>{{ footerInfo }}</b-alert>
                </b-col>
            </b-row>
            <div class="d-flex justify-content-center mt-3" v-if="!isReadOnly">
                <processing-button :processing="loading" variant="primary"
                                   :label="$t('save_and_go').toUpper()" @click="saveEducationInfo" />
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
import CitySelectbox from '@/components/interactive-fields/CitySelectbox'
import DistrictOutlineSelectbox from "@/components/interactive-fields/DistrictOutlineSelectbox"
import MultiSelectbox from '@/components/interactive-fields/MultiSelectbox'
import ProcessingButton from '@/components/elements/ProcessingButton'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import BisepService from "@/services/BisepService"

export default {
    name: "EducationInfoTab",
    components: {
        CitySelectbox,
        DistrictOutlineSelectbox,
        MultiSelectbox,
        ProcessingButton,
        ValidationObserver,
        ValidationProvider
    },
    props: {
        footerInfo: {
            type: String,
            default: ''
        },
        isReadOnly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localFormData:{},
            loading: false,
            highschoolClassOptions: [
                { value: '11', text: '11' },
                { value: '12', text: '12' },
                { value: 'M', text: this.$t('alumni') },
            ]
        }
    },
    mounted() {
        this.loadFormData()
    },
    methods: {
        loadFormData() {
            const data = this.getWithExpiry('bisep_app_data', true)
            if (data) {
                this.localFormData = { ...data }
            }
        },
        async saveEducationInfo() {
            const isValid = await this.$refs.educationInfoFormValidate.validate();
            if (isValid) {
                this.loading = true
                const pin = this.$store.getters['bisepApplication/getPin']
                const payload = {
                  ...this.localFormData,
                  national_id: this.localFormData.national_id,
                  pin: pin
                }
                
                BisepService.updateEducationInfo(payload).then(response => {
                    const updatedData = response.data.data
                    this.$store.commit('bisepApplication/setData', { data: updatedData })
                    this.$toast.success(this.$t('successfully_saved'))
                    this.$emit('success')
                }).catch(e => {
                    this.showErrors(e, this.$refs.educationInfoFormValidate)
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
}
</script>
